import styles from '../AveragesOverviewTable/style.postcss';

import React, { Component } from 'react';
import { OrderedMap } from 'immutable';
import is from 'is_js';
import PropTypes from 'prop-types';
import { ProductionStatus } from 'omni-common-ui';
import {
  TableView,
  TableViewTr,
  HeaderTd,
  NormalTd,
  ProgressCardTd,
  MemberCardTd,
} from 'components/TableView';
import { parseProductionStatus } from 'domain/ProductionStatus';
import ExpansionButton from 'components/ExpansionButton';

class SkillsAveragesTable extends Component {  // eslint-disable-line
  constructor(props) {
    super(props);
    this.state = {
      isExpand: false,
      sortKey: 'averageTotalScore',
      sortType: 'Ascending',
      filterParams: {},  // required for the TableView
    };
    this._handleOnFilterChange = this._handleOnFilterChange.bind(this);
  }

  _handleOnFilterChange(filterParams) {
    this.setState({ filterParams });
  }

  _renderTableHeaderRow(headers = new OrderedMap()) {  // overridden/used in PerformanceCard!
    const { sortKey, sortType } = this.state;
    const headerDescriptors = [{
      key: 'name', label: 'Name', sortable: true,
    }, {
      key: 'status', label: 'Status', sortable: false,
    }].concat(headers.map((skillName, skillId) => ({
      key: `${skillId}`, label: skillName, sortable: true,
    })).toArray());
    return <TableViewTr key="PerformanceCard-hrow2">
      {
        headerDescriptors.map((header) => <HeaderTd sortable={header.sortable}
            sortType={sortKey === header.key ? sortType : ''}
            onSort={() => this._sort(header.key)}
            key={header.label}>
          {header.label}
        </HeaderTd>)
      }
    </TableViewTr>;
  }

  _renderTableRow(row) {
    const { isInProduction } = row;
    const status = Object.assign({ isInProduction }, parseProductionStatus(row.status));
    return <TableViewTr key={`${row.studentGeneralInfo.id}-performance`}>
      <MemberCardTd name={`${row.studentGeneralInfo.firstName} ${row.studentGeneralInfo.lastName}`}
          surname={row.studentGeneralInfo.localName}
          avatarUrl={row.studentGeneralInfo.avatarUrl}
          gender={row.studentGeneralInfo.gender} />
      <NormalTd>
        <ProductionStatus status={row.status}
            highlighted={status.isInProduction} />
      </NormalTd>
      {
        this.skillMap.map((skillName, skillId) => {
          // todo: use a Map for these
          const scoreDescriptor = row.averageSkillScores.find((averageSkillScore) =>
            averageSkillScore.get('skillId') === skillId);
          if (! scoreDescriptor) return <NormalTd>-</NormalTd>;
          const key = `${scoreDescriptor.get('skillId')}-${row.studentGeneralInfo.id}`;
          return <ProgressCardTd key={key} percent={scoreDescriptor.get('score')} />;
        })
      }
    </TableViewTr>;
  }

  _renderExpansionButton() {
    const { groupPerformance } = this.props;
    if (groupPerformance.studentsPerformance.size <= 4) {
      return null;
    }
    return <ExpansionButton className={styles.PerformanceCard_expansion}
        isExpand={this.state.isExpand}
        onExpansionButtonClick={() => this.setState({ isExpand: ! this.state.isExpand })} />;
  }

  _sort(sortKey) {
    let sortType = 'Ascending';
    if (sortKey === this.state.sortKey) {
      sortType = this.state.sortType === 'Ascending' ? 'Descending' : 'Ascending';
    }
    this.setState({ sortKey, sortType });
  }

  render() {
    const { groupPerformance } = this.props;
    const { startUnitNumber, endUnitNumber } = groupPerformance;
    const tableTitle = startUnitNumber === endUnitNumber ?
      `Performance (Unit ${startUnitNumber})` :
      `Performance (Units ${startUnitNumber}-${endUnitNumber})`;
    const viewCount = groupPerformance.studentsPerformance.size >= 4 ? 4 :
      groupPerformance.studentsPerformance.size;
    const sortedstudentsPerformance = groupPerformance
      .studentsPerformance.sort((currentObject, nextObject) => {
        let current = currentObject.get(this.state.sortKey);
        let next = nextObject.get(this.state.sortKey);
        if (this.state.sortKey === 'name') {
          current = `${currentObject.studentGeneralInfo.firstName} ${currentObject.studentGeneralInfo.lastName}`.toLowerCase();
          next = `${nextObject.studentGeneralInfo.firstName} ${nextObject.studentGeneralInfo.lastName}`.toLowerCase();
        } else if (this.state.sortKey === 'averageTotalScore') {
          // bleh
        } else {
          const currentScoreDescriptor = currentObject.averageSkillScores.find((averageSkillScore) =>  // eslint-disable-line
            `${averageSkillScore.get('skillId')}` === this.state.sortKey);
          const nextScoreDescriptor = nextObject.averageSkillScores.find((averageSkillScore) =>
            `${averageSkillScore.get('skillId')}` === this.state.sortKey);
          current = currentScoreDescriptor && currentScoreDescriptor.get('score');
          next = nextScoreDescriptor && nextScoreDescriptor.get('score');
          current = is.number(current) ? current : null;
          next = is.number(next) ? next : null;
        }
        // Make sure none score student sorted bottom.
        if (this.state.sortType === 'Ascending') {
          current = current === null ? 101 : current;
          next = next === null ? 101 : next;
        } else if (this.state.sortType === 'Descending') {
          current = current === null ? - 101 : current;
          next = next === null ? - 101 : next;
        }
        // Make sure Swapped student sorted bottom.
        if (currentObject.status === 'Swapped') {
          return 1;
        } else if (nextObject.status === 'Swapped') {
          return - 1;
        }
        if (current > next) {
          return this.state.sortType === 'Ascending' ? 1 : - 1;
        } else if (current < next) {
          return this.state.sortType === 'Ascending' ? - 1 : 1;
        }
        return 0;
      });
    let skillMap = new OrderedMap();
    groupPerformance.studentsPerformance.forEach((studentsPerformance) => {
      const { averageSkillScores } = studentsPerformance;
      if (! averageSkillScores) return;
      averageSkillScores.forEach((averageSkillScore) => {
        skillMap = skillMap.set(averageSkillScore.get('skillId'), averageSkillScore.get('name'));
      });
    });
    this.skillMap = skillMap;  // bleh
    const source = this.state.isExpand ?
      sortedstudentsPerformance :
      sortedstudentsPerformance.slice(0, viewCount);
    return <TableView tableTitle={tableTitle}
        customerHeader={this._renderTableHeaderRow(skillMap)}
        renderTableRow={(row) => this._renderTableRow(row)}
        customerFooter={this._renderExpansionButton()}
        noResultsString="No Results."
        query={this.state.filterParams}
        onFilterChange={this._handleOnFilterChange}
        source={source} />;
  }
}

SkillsAveragesTable.propTypes = {
  groupPerformance: PropTypes.object.isRequired,
};

export default SkillsAveragesTable;



// WEBPACK FOOTER //
// ./containers/Group/Dashboard/PerformanceCard/SkillsAveragesTable/index.jsx